import axios from "./axiosInstance";
import { Globals } from "../global/Globals";

const fetchUser = async (email,password) => {
    const credentials={
        email:email,
        password:password
    }
    const config = {
        headers: {
          'Content-Type': 'application/json' // Set the Content-Type header
        }
      };
   const apiResponse = await axios.post(Globals.ENDPOINT.LOGIN,credentials,config);
   return apiResponse;
}
export default fetchUser;